<template>
  <div class="flex overflow-hidden">
    <div class="relative w-full h-auto">
      <img
        class="w-full h-full object-center object-cover"
        :class="imgClasses"
        :src="path"
        :alt="alt"
        :width="width"
        :height="height"
        :loading="eager ? 'eager' : 'lazy'"
      >
      <div
        v-if="credit"
        class="inline-block bottom-0 left-0 absolute bg-black bg-opacity-50 px-3 py-1 rounded-tr-lg w-auto text-white text-sm"
      >
        <p
          class="inline-block text-xs"
        >
          Foto: {{ credit }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  path: {
    type: String,
    required: true,
    // default: undefined,
  },
  alt: {
    type: String,
    required: false,
    // default: undefined,
  },
  credit: {
    type: String,
    required: true,
    // default: undefined,
  },
  imgClasses: {
    type: String,
    required: false,
    default: undefined,
  },
  width: {
    type: Number,
    required: false,
    default: undefined,
  },
  height: {
    type: Number,
    required: false,
    default: undefined,
  },
  eager: {
    type: Boolean,
    required: false,
    default: undefined,
  },
})
</script>
